import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import CounterCustomerChargeSearchPanel from "./CounterCustomerChargeSearchPanel";
import CounterCustomerChargeMaintenance from "./Detail/CounterCustomerChargeMaintenance";

export const CounterCustomerChargeMasterView: React.FC = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const { isShowDetailPanel } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();

    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                const results = await Promise.allSettled([
                    counterCustomerChargeVM.loadDropdownOption(),
                ]);
                results.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then(() => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [counterCustomerChargeVM])

    return <>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <div className="main-comp-wrapper im-hide-side-form-draggable">
            {/* {!isShowDetailPanel && < CounterCustomerChargeSearchPanel />}
            {isShowDetailPanel && <CounterCustomerChargeMaintenance />} */}
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowDetailPanel ? "0%" : "100%"}
                rightSectionWidth={isShowDetailPanel ? "100%" : "0%"}
                leftChildren={<CounterCustomerChargeSearchPanel />}
                rightChildren={<CounterCustomerChargeMaintenance />}
            />
        </div>
    </>
}